import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
  {
    path: '/transporte/traemissaopasse',
    name: 'traemissaopasse',
    description: 'Emissão de Passes',
    component: () => import('@/views/transporte/traemissaopasse/Index.vue'),
    meta: { permissions: [eTipoPermissao.EMISSAODEPASSESNOVO_MENU_1100200801] },
    goesToMenu: true,
  },
];
